<template>
  <div class="text-center">
    <p class="fz-2">
      データがみつからないようです。🥸 フィルターをかきかえてみてください 🔍
    </p>
    <div class="p-5 d-flex justify-content-center w-100">
      <img :src="'/public/logo.png'" height="200" width="400" class="my-4 img-fluid w-50 " />
    </div>
  </div>
</template>
